import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { FaPlay } from "react-icons/fa";
import { treadmill } from "ldrs";

import logo from "../assets/images/IMG_4242.PNG";
import { usePartnerState } from "../contexts/PartnerContext";
import { Card } from "../ui";
import CodeEntry from "../components/site/CodeEntry";

// Co-branded landing at /partner/:partnerSlug — the game code is the point of
// this page (a partner's screen), with the partner's logo (and, for premium
// partners, their theme via PartnerLayout's CSS variables). A discount code
// typed here still goes to pricing.
const PartnerLanding = () => {
  const { partnerSlug } = useParams();
  const { partner, isLoading, isError } = usePartnerState();
  const navigate = useNavigate();

  treadmill.register();

  // Unknown or inactive partner -> plain home page.
  useEffect(() => {
    if (isError) navigate("/");
  }, [isError, navigate]);

  if (isLoading) {
    return (
      <div className="h-[100vh] w-full flex justify-center items-center flex-col gap-5 bg-gradient-to-br from-background via-behindButton to-background">
        <l-treadmill size="120" speed="1.1" color="#FFFFFF" />
      </div>
    );
  }

  return (
    <div className="relative min-h-screen bg-gradient-to-br from-background via-behindButton to-background overflow-hidden font-sans">
      {/* Decorative elements (mirrors the home hero) */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-20 left-10 w-32 h-32 bg-white rounded-full blur-xl"></div>
        <div className="absolute bottom-20 right-10 w-40 h-40 bg-mainButton rounded-full blur-xl"></div>
        <div className="absolute top-1/2 left-1/4 w-24 h-24 bg-secondaryButton rounded-full blur-lg"></div>
      </div>

      <div className="relative z-10 flex flex-col items-center justify-center min-h-screen px-4 py-16">
        {/* Logos */}
        <div className="text-center mb-10">
          <div className="flex items-center justify-center gap-6 mb-6">
            {partner?.logo && (
              <>
                <img
                  src={partner.logo}
                  alt={partner.nameAr || partner.name}
                  className="w-24 md:w-36 lg:w-44 object-contain drop-shadow-2xl"
                />
                <div className="w-px h-16 md:h-24 bg-white/40"></div>
              </>
            )}
            <img
              src={logo}
              alt="تربع"
              className="w-28 md:w-44 lg:w-52 object-contain drop-shadow-2xl"
            />
          </div>

          {partner && (
            <h1
              className="text-white text-xl md:text-3xl font-bold drop-shadow-lg"
              style={{ direction: "rtl" }}
            >
              تربع بالشراكة مع {partner.nameAr || partner.name}
            </h1>
          )}
        </div>

        {/* Game Code Input Section */}
        <Card tone="solid" pad="lg" className="max-w-md w-full shadow-2xl shadow-black/30" dir="rtl">
          <h2 className="text-2xl md:text-3xl font-extrabold text-center text-white mb-6 flex items-center justify-center gap-3">
            ابدأ اللعب الآن <FaPlay className="text-xl text-primary" />
          </h2>
          <CodeEntry
            size="lg"
            submitLabel="إبدأ اللعبة"
            gamePath={(code) => `/partner/${partnerSlug}/${code}`}
          />
        </Card>
      </div>
    </div>
  );
};

export default PartnerLanding;
